import { ANTIRUG_CA } from '@/constants/antirug';

export type ParseCAResult =
  | {
      success: true;
      value: string;
    }
  | {
      success: false;
      error: string;
    };

export const parseCA = (input: string): ParseCAResult => {
  const trimmedInput = input.trim();
  if (!trimmedInput) {
    return { success: false, error: 'Please enter a valid CA or URL' };
  }

  // Check for specific input that requires a warning
  if (trimmedInput === ANTIRUG_CA) {
    return {
      success: false,
      error: "Sorry, we can't evaluate ourselves. The model might be biased.",
    };
  }

  // Try to parse as URL first
  try {
    const url = new URL(trimmedInput);
    if (url.hostname === 'pump.fun') {
      const afterCoin = url.pathname.split('/coin/')[1];
      if (afterCoin) {
        const ca = afterCoin.split('/')[0];
        return { success: true, value: ca };
      }
    }
  } catch {} // Invalid URL, continue with direct CA parsing

  if (/[0OIl]/.test(trimmedInput)) {
    return { success: false, error: 'Only SOL addresses are supported' };
  }

  // Try to find any base58-looking string in the input
  const caRegex = /[1-9A-HJ-NP-Za-km-z]{32,44}/;
  const match = trimmedInput.match(caRegex);

  if (!match) {
    return { success: false, error: 'SOL address should be 32-44 characters long.' };
  }

  return { success: true, value: match[0] };
};
